import gql from "graphql-tag"
import IngestionSourceFragment from "../fragment/IngestionSourceFragment"

export default gql`
  ${IngestionSourceFragment}
  mutation ingestionSourceAdd($input: IngestionSourceInput!) {
    ingestionSourceAdd(input: $input) {
      ...IngestionSourceFragment
    }
  }
`
